(ns quuppa.peweb.confirm
  ;; This is special case of modal
  ;; Consider adding general modal ns which this and others can use?
  (:require [re-frame.core :as rf]
            [quuppa.ui.modal :as modal]))

(rf/reg-event-db :confirm/close
  (fn [db [_]]
    (dissoc db :confirm)))

(rf/reg-event-fx :confirm/open
  (fn [{:keys [db]} [_ data]]
    {:db (assoc db :confirm data)}))

(rf/reg-sub ::confirm
  (fn [db]
    (:confirm db)))

(defn render-confirm []
  (let [{:keys [cancel-class ok-class
                cancel-label ok-label
                message title
                on-confirm]
         :or {cancel-class "btn btn-outline-primary"
              ok-class "btn btn-primary"}
         :as data}
        @(rf/subscribe [::confirm])]
    [modal/modal
     {:show data
      :on-hide #(rf/dispatch [:confirm/close])}
     [modal/header
      {:close-button true}
      [modal/title
       {}
       title]]
     [modal/body
      {}
      [:p.m-0.lead message]]
     [modal/footer
      {}
      [:button
       {:class cancel-class
        :on-click #(rf/dispatch [:confirm/close])}
       (or cancel-label "Cancel")]
      [:button
       {:class ok-class
        :on-click #(rf/dispatch on-confirm)}
       (or ok-label "OK")]]]))
